(function () {
  if (window.collectUpsellCartItems) return;

  class UpsellOffer extends HTMLElement {
    connectedCallback() {
      this.variantId = this.dataset.variantId;
      this.price = parseInt(this.dataset.variantPrice, 10) || 0;
      this.compareAtPrice = parseInt(this.dataset.variantCompareAtPrice, 10) || 0;
      this.quantity = 0;

      this.priceEl = this.querySelector('[data-upsell-price]');
      this.colorNameEl = this.querySelector('[data-upsell-color-name]');
      this.imageEl = this.querySelector('[data-upsell-image]');
      this.swatches = this.querySelectorAll('[data-upsell-swatch]');
      this.quantityInput = this.querySelector('[data-upsell-quantity]');

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => this.selectSwatch(swatch));
      });

      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', () => this.setQuantity(this.quantityInput.value));
      }
    }

    // Bubbles up to the page so a price-aware listener (e.g.
    // modular-configurator.js's updateComputedPrice()) can fold this
    // add-on's price into the displayed total - this element only knows
    // its own selected variant/quantity, not how the rest of the page
    // prices things.
    dispatchChange() {
      this.dispatchEvent(
        new CustomEvent('upsell-offer:change', {
          bubbles: true,
          detail: { selected: this.quantity > 0, quantity: this.quantity, price: this.price, compareAtPrice: this.compareAtPrice },
        })
      );
    }

    get selected() {
      return this.quantity > 0;
    }

    selectSwatch(swatch) {
      this.swatches.forEach((el) => {
        el.classList.toggle('upsell-offer__swatch--selected', el === swatch);
        el.setAttribute('aria-pressed', String(el === swatch));
      });

      this.variantId = swatch.dataset.variantId;
      this.price = parseInt(swatch.dataset.variantPrice, 10) || 0;
      this.compareAtPrice = parseInt(swatch.dataset.variantCompareAtPrice, 10) || 0;

      if (this.priceEl && typeof formatMoney === 'function') {
        this.priceEl.textContent = formatMoney(this.price);
      }
      if (this.colorNameEl) {
        this.colorNameEl.textContent = swatch.dataset.colorName || '';
      }
      if (this.imageEl && swatch.dataset.variantImage) {
        this.imageEl.src = swatch.dataset.variantImage;
        this.imageEl.srcset = '';
      }

      this.dispatchChange();
    }

    setQuantity(value) {
      var quantity = parseInt(value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 0;
      this.quantity = quantity;
      this.dispatchChange();
    }

    buildCartItem() {
      if (this.quantity < 1 || !this.variantId) return null;
      return {
        id: this.variantId,
        quantity: this.quantity,
        properties: {
          _upsell_offer: '1',
        },
      };
    }
  }

  customElements.define('upsell-offer', UpsellOffer);

  // Folded into modular-configurator.js's setupBundleSubmit() (and any other
  // future configurator using window.submitCartBundle) so a selected upsell
  // rides along in the same single /cart/add.js items[] call as the main
  // product instead of a second request. Returns [] when no <upsell-offer>
  // is present on the page or its quantity is currently 0.
  window.collectUpsellCartItems = function () {
    var items = [];
    document.querySelectorAll('upsell-offer').forEach(function (el) {
      var item = typeof el.buildCartItem === 'function' ? el.buildCartItem() : null;
      if (item) items.push(item);
    });
    return items;
  };
})();
